export default function delay(
  ms: number,
): Promise<ReturnType<typeof setTimeout>> {
  return new Promise(resolve => setTimeout(resolve, ms));
}
